module.exports = __webpack_public_path__ + "static/media/Head_1.019cf689.jpg";